"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkUUN3IUQ2_js = require('./chunk-UUN3IUQ2.js');
var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var o = require('styled-components');
var reactRadioGroup = require('@radix-ui/react-radio-group');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var o__default = /*#__PURE__*/_interopDefaultLegacy(o);

var t=o__default["default"](reactRadioGroup.Item)`
  all: unset;
  border-radius: 100%;
  border: 2px solid var(--foreground-secondary);
  height: 20px;
  max-width: 20px;
  min-width: 20px;

  &:hover {
    border-color: var(--foreground-primary);
  }

  &[data-state='checked'] {
    border: 2px solid var(--foreground-primary);
  }

  &:disabled,
  &[disabled] {
    border-color: var(--border-input-disabled);

    & + * {
      p {
        color: var(--foreground-disabled);
      }
    }
  }
`,i=o__default["default"](reactRadioGroup.Indicator)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;

  &::after {
    content: '';
    background-color: var(--border-boolean-active);
    border-radius: 100%;
    display: block;
    height: 12px;
    width: 12px;
  }

  &[data-disabled]::after {
    background-color: var(--foreground-disabled);
  }
`,l=o__default["default"].div`
  display: flex;
  flex-direction: column;
  padding: 12px 8px;
  user-select: none;

  &:hover {
    background-color: var(--background-boolean-hover);
    border-radius: var(--spacing-small);
    cursor: pointer;
  }

  &:focus {
    outline: 2px solid var(--border-boolean-active-hover);
    border-radius: var(--spacing-small);
  }

  :has([disabled]) {
    color: var(--foreground-disabled);
  }
`,n=o__default["default"](reactRadioGroup.Root)`
  display: flex;
  flex-direction: column;
  width: 100%;

  &[disabled] {
    cursor: not-allowed;
    user-events: none;

    ${t} {
      cursor: not-allowed;
      user-events: none;
    }
  }
`,s=o__default["default"].label`
  color: var(--foreground-primary);
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-regular);

  &:hover {
    cursor: pointer;
  }
`,p=o__default["default"](chunk2VCHSK65_js.d)`
  padding-left: var(--spacing-x-large);
  color: var(--foreground-tertiary);
`;var m=({id:d,label:x,description:g,...v})=>jsxRuntime.jsx(s,{htmlFor:d,children:jsxRuntime.jsxs(l,{tabIndex:0,children:[jsxRuntime.jsxs(chunkUUN3IUQ2_js.a,{yAlign:"center",spacing:"small",children:[jsxRuntime.jsx(t,{...v,id:d,children:jsxRuntime.jsx(i,{})}),x]}),jsxRuntime.jsx(chunkUUN3IUQ2_js.a,{yAlign:"center",children:jsxRuntime.jsx(p,{size:"small",children:g})})]})});m.displayName="RadioItem";var u=o__default["default"](m)``;var f=n;f.displayName="RadioGroup";var b=f;var w={Item:u,Group:b};

exports.a = w;
